import React, { useEffect, useState } from "react";
import {
  faBarcode,
  faCalendar,
  faMapMarkerAlt,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "../../Components/Button/Button";
import Style from "./Item.module.css";
import SuppliersInfo from "../SuppliersInfo/SuppliersInfo";
import { setDeliveredApi } from "../../Api/DeliveryBarest";
import { errorToast } from "../../Utils/Toast/Toast";
import { Modal } from "antd";
// import Modal from "../Modal/Modal";

const Item = ({
  setPurchased,
  setShow,
  btnAccept,
  deliver,
  data,
  address,
  orderlist,
  parentCallbackId,
  parentCallback,
  time,
  peykData=[]
}) => {
  const [dataProduct, setDataProduct] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [orderId, setOrderId] = useState();
  const [code, setCode] = useState();
  const [disable, setDisable] = useState(false);

  // useEffect(() => {
  //   if (dataProduct) {
  //     ordersList(dataProduct);
  //   }
  // }, []);

  ////send supplier info to parent///
  const acceptOrder = (item) => {
    setShow(true);
    parentCallbackId([item.id, item.suppliers]);
  };
  /////get products of a order  from child/////
  const handleCallback = (childData) => {
    ordersList(childData);
  };
  ////send item id to parent //////
  const ordersList = (product) => {
    parentCallback(product.products);
    setPurchased(true);
  };
  /////get products of a order  from child/////
  // const handleCallback = (childData) => {
  //   setDataProduct(childData);
  //   ordersList(dataProduct);
  // };
  ////////////open modal of send delivery code//////
  const openModalFunc = (id) => {
    setOpenModal(true);
    setOrderId(id);
  };
  //////oreder Delivered/////////
  const orderDelivered = () => {
    setDisable(true);
    let info = {
      id: orderId,
      delivery_code: code,
    };
    setDeliveredApi(info, (suc) => {
      if (suc.status === 1) {
        setDisable(false);
        window.location.reload();
      } else {
        setDisable(false);
        errorToast(suc.message);
      }
    });
  };
  return (
    <div className={Style.ParentDive}>
      <Modal
        open={openModal}
        onCancel={() => setOpenModal(false)}
        style={{ direction: "rtl" ,fontFamily:'iran-sans-num'}}
        footer={null}
        destroyOnClose
        title="وارد کردن کد"
      >
                <div className={Style.modalHolder}>
          <input
            className={Style.codeInput}
            onChange={(e) => setCode(e.target.value)}
          />
          <button
            onClick={orderDelivered}
            className={Style.sendBtn}
            disabled={disable}
          >
            ارسال
          </button>
        </div>
      </Modal>
      {data.length=== 0&&peykData.length===0  ? (
        <div className={Style.NotOrderFoundHolder}>
          <div className={Style.ImageBasket}>
            <img src="/Assets/Images/Order/emtyOreder.svg" alt="barest" />
          </div>
          <p className={Style.NoOrderText}>سفارشی یافت نشد</p>
        </div>
      ) : (
        data.map((item, index) => {
          return (
            <div key={index} className={Style.eachItem}>
              <div className={Style.orderCode}>
                <div className={Style.date}>
                  <h3 className={Style.textDate}>
                    {item.date}
                    <FontAwesomeIcon className={Style.icon} icon={faCalendar} />
                  </h3>
                </div>
                <div className={Style.code}>
                  <span className={Style.codeNumber}>{item.id}</span>
                  <h3 className={Style.textCode}>
                    :کدسفارش
                    <FontAwesomeIcon className={Style.icon} icon={faBarcode} />
                  </h3>
                </div>
              </div>

              <SuppliersInfo
                deliver={deliver}
                time={time}
                orderlist={orderlist}
                data={item.suppliers}
                itemId={item.id}
                setPurchased={setPurchased}
                parentCallback={handleCallback}
              />

              <div className={Style.customerInfo}>
                <div className={Style.date}>
                  <h3 className={Style.textCode}>
                    <FontAwesomeIcon className={Style.icon} icon={faUser} />
                    مشتری
                  </h3>
                </div>
                <div className={Style.date}>
                  <h3 className={Style.textCode}>
                    <FontAwesomeIcon
                      className={Style.icon}
                      icon={faMapMarkerAlt}
                    />
                    {item.address}
                  </h3>
                </div>
                {address ? (
                  <div className={Style.date}>
                    <h3 className={Style.textCode}>
                      {"خیابان: " +
                        item.street +
                        "," +
                        "کوچه: " +
                        item.alley +
                        "," +
                        "محله: " +
                        item.district +
                        "," +
                        "ساختمان: " +
                        item.apartment_name +
                        "," +
                        "واحد: " +
                        item.apartment_number +
                        "," +
                        "پلاک: " +
                        item.plate}
                    </h3>
                  </div>
                ) : null}
                <div className={Style.h3Holder}>
                  {localStorage.getItem("type") === "android" ? (
                    <h3 className={Style.goMap}>
                      <a
                        className={Style.showInMap}
                        href={`geo:${item.lon},${item.lat}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {" "}
                        نمایش آدرس در نقشه
                      </a>
                    </h3>
                  ) : null}
                  {localStorage.getItem("type") === "ios" ||
                  localStorage.getItem("type") === "desktop" ? (
                    <h3 className={Style.goMap}>
                      <a
                        className={Style.showInMap}
                        href={`https://maps.apple.com/?q=${item.lat} + ${item.lom}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        نمایش آدرس در نقشه
                      </a>
                    </h3>
                  ) : null}
                  {deliver ? (
                    <h3
                      className={Style.deliver}
                      onClick={() => openModalFunc(item.id)}
                    >
                      تحویل دادم
                    </h3>
                  ) : null}
                </div>
              </div>
              <div className={Style.btnsHolder}>
                {btnAccept ? (
                  <Button
                    Value={"قبول سفارش"}
                    ClickHandler={() => acceptOrder(item)}
                    ClassBtn={"confirmBtn"}
                  />
                ) : (
                  <a className={Style.aTag} href={`tel:${item.phone}`}>
                    تماس با گیرنده
                  </a>
                )}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};
export default Item;
